export const PAGES = {
  LOGIN: '/',
  REGISTER: '/register',
  DASHBOARD: '/dashboard/overview',
  FILES: '/dashboard/files/home',
  LAB_DASHBOARD: '/dashboard/lab/overview',
  LAB_ORDERS: '/dashboard/lab/orders',
  LAB_PRACTICES: '/dashboard/lab/practices',
  LAB_TASKS: '/dashboard/lab/tasks',
  LABS: '/dashboard/labs',
  NOTIFICATIONS: '/dashboard/notifications',
  ORDERS: '/dashboard/orders',
} as const;
